/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_Agent_Image_StatusInputs */

const tr_landing_genius_agent_image_status = /** @type {(inputs: Landing_Genius_Agent_Image_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T-Shirt Slim Fit · ürün fotoğrafından Trendyol görseli hazır.`)
};

const en_landing_genius_agent_image_status = /** @type {(inputs: Landing_Genius_Agent_Image_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T-Shirt Slim Fit · Trendyol image ready from the product photo.`)
};

const de_landing_genius_agent_image_status = /** @type {(inputs: Landing_Genius_Agent_Image_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T-Shirt Slim Fit · Trendyol-Bild aus dem Produktfoto fertig.`)
};

const ru_landing_genius_agent_image_status = /** @type {(inputs: Landing_Genius_Agent_Image_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Футболка Slim Fit · изображение для Trendyol из фото товара готово.`)
};

/**
* | output |
* | --- |
* | "T-Shirt Slim Fit · Trendyol image ready from the product photo." |
*
* @param {Landing_Genius_Agent_Image_StatusInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_agent_image_status = /** @type {((inputs?: Landing_Genius_Agent_Image_StatusInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_Agent_Image_StatusInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_agent_image_status(inputs)
	if (locale === "de") return de_landing_genius_agent_image_status(inputs)
	if (locale === "ru") return ru_landing_genius_agent_image_status(inputs)
	return tr_landing_genius_agent_image_status(inputs)
});